// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create Event via Google Calendar
 * @param {*} data
 * @returns
 */
export function createGoogleCalendarEvent(data: any): any {
    const baseUrl = `${config.server.api}/v1/google-calendar/events`;
    return api.create(baseUrl, data);
}

